import React, { useEffect } from 'react';
// external imports
import {
  FormControl,
  InputLabel,
  Input,
  Button,
  AppBar,
  Toolbar,
  FormHelperText,
} from '@material-ui/core';
// internal imports
import { useSetState } from '~/app/Utility/customHooks';
// redux imports
import { useSelector, useDispatch } from 'react-redux';
import { actions as setupPageActions } from '~/app/redux/setupPages/duck';
import { formHasErrors } from '../databaseSetupHelper';

const UpsertBankRTN = props => {
  const dispatch = useDispatch();

  const [state, setState] = useSetState({
    inputErrors: {},
    isSubmitDisabled: false,
  });

  const { isEditingRecord, currentEditRecord } = useSelector(state => ({
    isEditingRecord: state.setupPageState.isEditingRecord,
    currentEditRecord: state.setupPageState.currentEditRecord,
  }));

  useEffect(() => {
    setState({
      isSubmitDisabled: formHasErrors(currentEditRecord, handleSetErrors),
    });
  }, [currentEditRecord]);

  const handleSetErrors = errors => {
    setState({ inputErrors: errors }); // set any errors to the local state
  };

  const handleInputChange = e => {
    e.persist();
    dispatch(setupPageActions.updateCurrentEditRecord(e));
  };

  const handleUpsert = () => {
    props.handleUserDBUpsert(currentEditRecord);
  };

  const validateFields = () => {
    if (
      currentEditRecord.bank_rtn == null ||
      currentEditRecord.bank_rtn === '' ||
      currentEditRecord.bank_name == null ||
      currentEditRecord.bank_name === ''
    ) {
      return false;
    }
    return true;
  };

  return (
    <div>
      <AppBar position="static">
        <Toolbar style={styles.toolbar}>{isEditingRecord ? 'Edit ' : 'Add '} BankRTNs</Toolbar>
      </AppBar>
      <form style={{ margin: ' 2em' }}>
        <div style={{ textAlign: 'left', marginTop: '1em' }}>
          <div style={styles.sectionHeading}>Bank RTN</div>
          <div style={{ float: 'left', marginRight: '2em' }}>
            <FormControl>
              <InputLabel style={styles.labelStyles} required={false} shrink>
                RTN
              </InputLabel>
              <Input
                id="txtBankRtnUpsertBankRtnNumber"
                name="bank_rtn"
                value={currentEditRecord.bank_rtn}
                onChange={handleInputChange}
                style={styles.inputStyle}
                error={
                  !currentEditRecord.bank_rtn ||
                  currentEditRecord.bank_rtn === '' ||
                  state.inputErrors?.bank_rtn !== undefined
                }
                inputProps={{
                  maxLength: '30',
                }}
                disableUnderline
              />
              {state.inputErrors?.bank_rtn && (
                <FormHelperText>{state.inputErrors.bank_rtn}</FormHelperText>
              )}
            </FormControl>
          </div>
          <div style={{ float: 'none' }}>
            <FormControl>
              <InputLabel style={styles.labelStyles} required={false} shrink>
                Bank Name
              </InputLabel>
              <Input
                id="txtBankRtnUpsertBankRtnName"
                name="bank_name"
                value={currentEditRecord.bank_name}
                onChange={handleInputChange}
                style={styles.inputStyle}
                error={
                  !currentEditRecord.bank_name ||
                  currentEditRecord.bank_name === '' ||
                  state.inputErrors?.bank_name !== undefined
                }
                inputProps={{
                  maxLength: '75',
                }}
                disableUnderline
              />
              {state.inputErrors?.bank_name && (
                <FormHelperText>{state.inputErrors.bank_name}</FormHelperText>
              )}
            </FormControl>
          </div>
        </div>

        <div style={{ textAlign: 'right', margin: '2em' }}>
          <Button
            id="btnCancelAddUpsertBankRtn"
            color="primary"
            onClick={() => props.handleCloseUpsertModal()}
          >
            Cancel
          </Button>
          <Button
            id="btnUpsertBankRtn"
            color="primary"
            style={styles.button}
            onClick={handleUpsert}
            disabled={!validateFields() || state.isSubmitDisabled}
          >
            {isEditingRecord ? 'Save' : 'Add'}
          </Button>
        </div>
      </form>
    </div>
  );
};

const styles = {
  labelStyles: {
    color: '#354052',
    textAlign: 'left',
    fontFamily: 'Roboto',
  },
  button: {
    width: '9em',
    fontSize: '14px',
    borderRadius: '4px',
    marginLeft: '2em',
  },
  toolbar: {
    backgroundColor: '#444A59',
  },
  sectionHeading: {
    color: '#1A173B',
    fontFamily: 'Roboto',
    fontSize: '21px',
    marginBottom: '1em',
  },
  inputStyle: {
    width: '20vw',
    height: '3.5vh',
  },
};

export default UpsertBankRTN;
